<form class="ui form" #form="ngForm" [class.loading]="isLoading">
    <!-- Self -->
    <div class="ui segment">
        <app-segment-header title="performance.goal-participants.selfContributionTitle"></app-segment-header>

        <mat-checkbox
            (change)="trackSelectingSelfAsParticipant($event)"
            [ngModel]="participants.get(self.id)"
            (ngModelChange)="participants.set(self.id, $event)"
            name="self"
            ><app-avatar [employee]="self" [name]="true"></app-avatar
        ></mat-checkbox>
    </div>

    <!-- Direct Reports -->
    <div class="ui segment">
        <app-segment-header title="performance.goal-participants.directReportsTitle">
            <div class="buttons">
                <ui-button type="link" (click)="selectAll(directReports)">
                    {{ 'performance.goal-participants.selectAll' | translate }}
                </ui-button>
                <ui-button type="link" (click)="deselectAll(directReports)">
                    {{ 'performance.goal-participants.deselectAll' | translate }}
                </ui-button>
            </div>
        </app-segment-header>

        <div class="employee-list">
            <mat-checkbox
                *ngFor="let employee of directReports; let i = index"
                [attr.name]="'directReport' + i"
                [ngModel]="participants.get(employee.id)"
                (ngModelChange)="participants.set(employee.id, $event)"
                (change)="trackSelectingOfParticipantsWhoHaveDirectReports($event)"
                ><app-avatar [employee]="employee" [name]="true"></app-avatar
            ></mat-checkbox>
        </div>

        <div
            *ngIf="!directReports.length"
            [innerHTML]="
                'performance.goal-participants.selfDoesNotHaveAnyDirectReports'
                    | translate: { selfName: self?.fullName ?? '-' }
                    | sanitizeHtml
            "
        ></div>
    </div>

    <!-- Peers -->
    <div class="ui segment">
        <app-segment-header title="performance.goal-participants.selectPeersTitle">
            <div class="buttons">
                <ui-button type="link" (click)="selectAll(peers)">
                    {{ 'performance.goal-participants.selectAll' | translate }}
                </ui-button>
                <ui-button type="link" (click)="deselectAll(peers)">
                    {{ 'performance.goal-participants.deselectAll' | translate }}
                </ui-button>
            </div>
        </app-segment-header>

        <div class="employee-list">
            <mat-checkbox
                *ngFor="let employee of peers; let i = index"
                [name]="'peer' + i"
                [ngModel]="participants.get(employee.id)"
                (ngModelChange)="participants.set(employee.id, $event)"
                (change)="trackSelectingOfParticipantsWhoArePeers($event)"
                ><app-avatar [employee]="employee" [name]="true"></app-avatar
            ></mat-checkbox>
        </div>

        <div
            *ngIf="!peers.length"
            [innerHTML]="
                'performance.goal-participants.selfDoesNotHaveAnyPeers'
                    | translate: { selfName: self?.fullName ?? '-' }
                    | sanitizeHtml
            "
        ></div>
    </div>
</form>
